import { ErrorStateMatcher } from '@angular/material/core';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';

export class GenericErrorStateMatcher implements ErrorStateMatcher {

  targetParentFormErrors: string[] = null;

  constructor(targetParentFormErrors?: string[]) {
    this.targetParentFormErrors = targetParentFormErrors ? targetParentFormErrors : null;
  }

  isErrorState(control: FormControl, form: FormGroupDirective | NgForm): boolean {
    const formErrors: string[] = form && form.errors && form.errors !== undefined ? Object.keys(form.errors) : [];
    const crossFieldErrorsPresent: boolean = this.targetParentFormErrors === null || this.targetParentFormErrors.length <= 0 ? false :
      formErrors !== null && formErrors.length > 0 ?
      formErrors.reduce((acc: boolean, cur: string) => this.targetParentFormErrors.includes(cur) || acc, false) : false;

    return (control.touched || control.dirty || (form && form.submitted) ) && (control.invalid || crossFieldErrorsPresent);
  }
}
